export function getTextColor(backgroundColor: string | undefined): 'black' | 'white' {
  // Default to black if the color is invalid
  if (!backgroundColor || !/#[0-9A-Fa-f]{6}/.test(backgroundColor)) {
    return 'black'
  }

  // Convert hex to RGB
  const { r, g, b } = getRgbFromHex(backgroundColor)

  const luminance = getLuminance(r, g, b)

  // Use white text for dark backgrounds, black text for light backgrounds
  return luminance / 255 > 0.5 ? 'black' : 'white'
}

export function getBorderColor(backgroundColor: string | undefined): string {
  if (!backgroundColor || !/#[0-9A-Fa-f]{6}/.test(backgroundColor)) {
    return 'gray'
  }

  const { r, g, b } = getRgbFromHex(backgroundColor)

  // Range is 0 (black) to 255 (white)
  const luminance = getLuminance(r, g, b)

  // If background is very dark (close to black) or very light (close to white), return gray
  if (luminance < 30 || luminance > 200) return 'gray'

  return backgroundColor
}

const getRgbFromHex = (hex: string): { r: number; g: number; b: number } => {
  return {
    r: parseInt(hex.substring(1, 3), 16),
    g: parseInt(hex.substring(3, 5), 16),
    b: parseInt(hex.substring(5, 7), 16),
  }
}

const getLuminance = (r: number, g: number, b: number): number => {
  return 0.199 * r + 0.487 * g + 0.114 * b
}
